import { useDispatch } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { closeErrorDialog } from "../../Redux/Actions/InputData";
import ErrorIcon from "@mui/icons-material/ErrorOutlined";
import "./errorstyle.css";
import { Button, DialogActions, Typography } from "@mui/material";
import { red } from "@mui/material/colors";

function ErrorDialog(props: any) {
  const dispatch: any = useDispatch();

  const handleCloseErrorDialog = () => {
    dispatch(closeErrorDialog());
  };

  // const renderErrorMessage = () => {
  //   const msg = props.errorMessage ?? "";
  //   const parts = String(msg)
  //     .split(";")
  //     .map((p: string) => p.trim())
  //     .filter(Boolean);
  //   if (parts.length === 0) return null;
  //   return parts.map((p: string, i: number) => (
  //     <span key={i}>
  //       {i + 1}
  //       {p}
  //       {i < parts.length - 1 && <br /> && <br />}
  //     </span>
  //   ));
  // };

  const renderErrorMessage = () => {
    const msg = props.errorMessage ?? "";
    // split on newlines or semicolons, trim and remove empties
    const parts = String(msg)
      .split(/\r?\n|;/)
      .map((p: string) => p.trim())
      .filter(Boolean);
    if (parts.length === 0) return null;

    if (parts.length === 1) {
      return <div>{parts[0]}</div>;
    }

    const last = parts[parts.length - 1];
    const items = parts.slice(0, parts.length - 1);

    return (
      <div>
        <ol style={{ margin: "0 0 8px 16px", padding: 0 }}>
          {items.map((it: string, i: number) => (
            <li key={i} style={{ marginBottom: 6 }}>
              {it.replace(/^\d\s*[:.)-]?\s*/g, "")}
            </li>
          ))}
        </ol>
        <br />
        <div style={{ marginTop: 6 }}>
          {last.replace(/^\d\s*[:.)-]?\s*/g, "")}
        </div>
      </div>
    );
  };
  return (
    <>
      <Dialog
        onClose={handleCloseErrorDialog}
        aria-labelledby="customized-dialog-title"
        open={props.isErrorDialog}
      >
        <DialogTitle id="customized-dialog-title">
          <ErrorIcon sx={{ color: red[500], fontSize: 14 }} />
          <div className="modal-error-title">ERROR</div>
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {props.errorMessage ? (
              <div>{renderErrorMessage()}</div>
            ) : (
              <div>Network Connection Error! Please Try after Sometime...</div>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ErrorDialog;
